var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67157 0.464318L10.8536 3.6463C11.0488 3.84156 11.0488 4.15814 10.8536 4.3534L7.67157 7.53539C7.47631 7.73065 7.15973 7.73065 6.96447 7.53539C6.7692 7.34012 6.7692 7.02354 6.96447 6.82828L9.29289 4.49985H0.5C0.223858 4.49985 0 4.27599 0 3.99985C0 3.72371 0.223858 3.49985 0.5 3.49985H9.29289L6.96447 1.17142C6.7692 0.976162 6.7692 0.65958 6.96447 0.464318C7.15973 0.269056 7.47631 0.269056 7.67157 0.464318Z",
    fill: "#485637"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.b48e34ad7840412cf8ec5deb57d8ad63.svg";
export { ForwardRef as ReactComponent };